import { addClass, removeClass } from '@tyler-components-web/core';
import { RIPPLE_CONSTANTS } from './ripple-constants';
import { TylRipple } from './tyl-ripple';
var RippleAdapter = /** @class */ (function () {
    function RippleAdapter(_component) {
        this._component = _component;
    }
    RippleAdapter.prototype._tryFindTarget = function () {
        return this._component.parentElement;
    };
    RippleAdapter.prototype.initialize = function (target, unbounded) {
        if (target) {
            this._target = (this._component.ownerDocument || document).querySelector(target);
        }
        if (!this._target) {
            this._target = this._tryFindTarget();
        }
        if (this._target) {
            this._ripple = new TylRipple(this._target);
            this._ripple.unbounded = unbounded;
            addClass(RIPPLE_CONSTANTS.classes.SURFACE, this._target);
        }
    };
    RippleAdapter.prototype.destroy = function () {
        if (this._ripple) {
            this._ripple.destroy();
            this._ripple = undefined;
        }
        if (this._target) {
            removeClass(RIPPLE_CONSTANTS.classes.SURFACE, this._target);
        }
        this._target = undefined;
    };
    return RippleAdapter;
}());
export { RippleAdapter };
